import { AstroTransitionLink } from "@components/AstroTransitionLink"
import type { BackButtonProps } from "@site-types/components/backButton"
import { useRouteShellContext } from "@components/routeShellContext"
import "./styles.css"

export function BackButton({ backPage }: BackButtonProps) {
  const { locale, currentPage } = useRouteShellContext()
  const destination = `/${locale}/${backPage || currentPage}`

  return (
    <AstroTransitionLink
      to={destination}
      data-testid="back-button"
    >
      <i className="fa-sharp fa-regular fa-arrow-left" />
    </AstroTransitionLink>
  )
}

export default BackButton
